/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createPrint } from '../../factoriesAny.js';
export var printDependencies = {
  typedDependencies: typedDependencies,
  createPrint: createPrint
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesPrint.generated.js
// module id = 1619
// module chunks = 0